import React from 'react';

import FieldViewer from 'components/marketing/surveys/form_builder/FormBuilder_FieldViewer';

class FormViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {}
    };

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleFieldChange(name, value) {
    this.setState((prevState) => {
      prevState.formData[name] = value;

      return prevState;
    });
  }

  handleSubmit() {
    if (this.props.onSubmit) {
      return this.props.onSubmit(this.state.formData);
    }
  }

  render() {
    if (!this.props.schema) {
      return <p className="text-danger"><i className="fa fa-danger" /> no schema</p>;
    }

    return (
      <div>
        {
          this.props.schema.fields.map((field) => {
            console.dir(field);

            return <FieldViewer field={field} value={this.state.formData[field.name] !== undefined ? this.state.formData[field.name] : ''} onChange={(value) => {this.handleFieldChange(field.name, value)}} />;
          })
        }

        <p><input className="btn btn-primary" type="submit" onClick={this.handleSubmit} /></p>
      </div>
    )
  }
}

export default FormViewer;


// WEBPACK FOOTER //
// ./src/components/marketing/surveys/FormViewer.js